import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-free-trial-style-three',
  templateUrl: './free-trial-style-three.component.html',
  styleUrls: ['./free-trial-style-three.component.scss']
})
export class FreeTrialStyleThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
